import { TranslationModule } from "../translation/translation.module";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { OverlayModule } from "@angular/cdk/overlay";
import { PipesModule } from "../shared/pipes/pipes.module";

import { RouterModule } from "@angular/router";

import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { ProductCardShimmerComponent } from "./product-card-shimmer/product-card-shimmer.component";
import { BreadCrumbComponent } from "./bread-crumb/bread-crumb.component";
import { ClientServiceCardComponent } from "./client-service-card/client-service-card.component";
import { AppliedFilterComponent } from "./filter/applied-filter/applied-filter.component";
import { BrandFilterComponent } from "./filter/brand-filter/brand-filter.component";
import { CategoryFilterComponent } from "./filter/category-filter/category-filter.component";
import { ChildCategoriesFilterComponent } from "./filter/category-filter/child-categories-filter/child-categories-filter.component";
import { FilterComponent } from "./filter/filter.component";
import { PriceFilterComponent } from "./filter/price-filter/price-filter.component";
import { SearchFilterComponent } from "./filter/search-filter/search-filter.component";
import { ForgotPasswordDialogComponent } from "./forgot-password-dialog/forgot-password-dialog.component";
import { GoToTopComponent } from "./go-to-top/go-to-top.component";
import { HeaderCartComponent } from "./header-cart/header-cart.component";
import { HeaderUserProfileDropDownComponent } from "./header-user-profile-drop-down/header-user-profile-drop-down.component";
import { WishListComponent } from "./header-wish-list/wish-list.component";
import { InputQuantityComponent } from "./input-quantity/input-quantity.component";
import { LoginDialogComponent } from "./login-dialog/login-dialog.component";
import { MenuComponent } from "./menu/menu.component";

import { PopUpConfirmationComponent } from "./pop-up-confirmation/pop-up-confirmation.component";
import { ServiceCommercialDialogComponent } from "./service-commercial-dialog/service-commercial-dialog.component";
import { ServiceCommercialComponent } from "./service-commercial-dialog/service-commercial/service-commercial.component";
import { forgotPasswordPopupComponent } from "./forgot-password-popup/forgot-password-popup.component";
import { NotificationPopupComponent } from "./notification-popup/notification-popup.component";
import { NotificationComponent } from "./notification/notification.component";
import { RegistrationDialogComponent } from "./registration-dialog/registration-dialog.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { LoginComponent } from "admin-common";

import { SubscriptonModalComponent, ModalComponent } from "admin-common";
import { ForgotPasswordEmailComponent } from "admin-common";
import { ForgotPasswordResetComponent } from "admin-common";
import { SnackbarComponent } from "admin-common";
@NgModule({
  declarations: [
    ProductCardShimmerComponent,
    BreadCrumbComponent,
    ClientServiceCardComponent,
    AppliedFilterComponent,
    LoginDialogComponent,
    BrandFilterComponent,
    CategoryFilterComponent,
    ChildCategoriesFilterComponent,
    FilterComponent,
    PriceFilterComponent,
    SearchFilterComponent,
    ForgotPasswordDialogComponent,
    forgotPasswordPopupComponent,
    ResetPasswordComponent,
    NotificationPopupComponent,
    NotificationComponent,
    GoToTopComponent,
    HeaderCartComponent,
    HeaderUserProfileDropDownComponent,
    WishListComponent,
    InputQuantityComponent,
    MenuComponent,
    RegistrationDialogComponent,
    PopUpConfirmationComponent,
    ServiceCommercialComponent,
    ServiceCommercialDialogComponent,
  ],
  imports: [
    TranslationModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SnackbarComponent,
    OverlayModule,
    PipesModule,
    NgxSliderModule,
    LoginComponent,
    ForgotPasswordEmailComponent,
    ForgotPasswordResetComponent,
    SubscriptonModalComponent,
    ModalComponent,
    RouterModule.forChild([]),
  ],
  exports: [
    TranslationModule,
    ProductCardShimmerComponent,
    BreadCrumbComponent,
    ClientServiceCardComponent,
    AppliedFilterComponent,
    BrandFilterComponent,
    CategoryFilterComponent,
    ChildCategoriesFilterComponent,
    FilterComponent,
    LoginDialogComponent,
    PriceFilterComponent,
    SearchFilterComponent,
    ForgotPasswordDialogComponent,
    ResetPasswordComponent,
    RegistrationDialogComponent,
    GoToTopComponent,
    HeaderCartComponent,
    HeaderUserProfileDropDownComponent,
    WishListComponent,
    InputQuantityComponent,
    MenuComponent,
    PopUpConfirmationComponent,
    ServiceCommercialComponent,
    ServiceCommercialDialogComponent,
    NotificationComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GlobalModule {}
